export default __webpack_public_path__ + "svg/CompaniesLogos/logo_aws.svg?35ab1399";